<template>
    <div>
        <breadcrumbs class="mb-3" />
        <v-btn variant="flat" :to="{name: 'member', params: {id: 0}}" class="bg-primary mb-4">
            {{ $t('new_member_profile') }}
        </v-btn>
        <clients-table :is-member="true" :users="users" :users-loading="usersLoading" />
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {CompanyClientsPage} from '@/pages/account/CompanyClientsPage.vue'

    // TODO [P1] Need check setup inheritance
    @Component({})
    export class MembersPage extends CompanyClientsPage {}

    export default MembersPage
</script>
